var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.25C6.12614 21.25 1.75 16.8739 1.75 11.5C1.75 6.12614 6.12614 1.75 11.5 1.75C16.8739 1.75 21.25 6.12614 21.25 11.5C21.25 16.8739 16.8739 21.25 11.5 21.25ZM11.5 2.25C6.39349 2.25 2.25 6.40423 2.25 11.5C2.25 16.5958 6.39349 20.75 11.5 20.75C16.6065 20.75 20.75 16.5958 20.75 11.5C20.75 6.40423 16.6065 2.25 11.5 2.25Z",
    fill: "#4B4AD5",
    stroke: "#4B4AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 22.2495C21.9354 22.2495 21.8748 22.2272 21.8235 22.1759L19.8235 20.1759C19.7288 20.0812 19.7288 19.9177 19.8235 19.823C19.9182 19.7283 20.0817 19.7283 20.1764 19.823L22.1764 21.823C22.2711 21.9177 22.2711 22.0812 22.1764 22.1759C22.1251 22.2272 22.0645 22.2495 21.9999 22.2495Z",
    fill: "#4B4AD5",
    stroke: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchColored);
export default __webpack_public_path__ + "static/media/search-colored.0a4d491d9fa476959168e212962690bc.svg";
export { ForwardRef as ReactComponent };